import * as yup from 'yup';

export const emailSchema = yup
  .string()
  .required('Email is required')
  .email('Enter a valid email address');

export const passwordSchema = yup
  .string()
  .required('Password is required')
  .min(6, 'Password must be at least 6 characters')
  .matches(/[A-Z]/, 'Password must include at least one uppercase letter')
  .matches(/[0-9]/, 'Password must include at least one number');

export const signUpSchema = yup.object({
  email: emailSchema,
  password: passwordSchema,
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
});

export type SignUpFormValues = yup.InferType<typeof signUpSchema>;
